import { Component, Inject, Input, OnChanges } from '@angular/core';
import { WINDOW } from '@ng-web-apis/common';
import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { TranslateService } from '@shared/translate/translate.service';
import get from 'lodash/get';
import { CartHandlerService } from '@literature/services/cart-handler.service';
import { LiteratureDocument, LiteratureDocumentListingData } from '@types';
import { detailsGenerator } from '@literature/literature-utils';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'ft-document-detail',
  templateUrl: './document-detail.component.html',
  styleUrls: ['./document-detail.component.scss'],
  providers: [DatePipe],
})
export class DocumentDetailComponent
  implements ICellRendererAngularComp, OnChanges {
  @Input() cellRendererData: LiteratureDocumentListingData;
  @Input() convertDateTo: string;
  cellvalue: any[] | string = [];
  clientUseValue = [];
  isSiteIntl: boolean;
  clientUse: string;
  isInvestor: boolean;
  showPublicationDate: boolean;
  /**
   * Params
   */
  public params;
  constructor(
    @Inject(WINDOW) readonly windowRef: Window,
    private translateService: TranslateService,
    private cartService: CartHandlerService,
    private dateFormatter: DatePipe
  ) {}
  ngOnChanges(): void {
    if (this.cellRendererData) {
      this.agInit(this.cellRendererData);
    }
  }

  refresh(params: any): boolean {
    this.params = params;
    this.isSiteIntl = get(params, 'isSiteIntl', true);
    this.clientUseValue = this.finraGenerator(params.data.literatureData);
    this.cellvalue = this.detailGenerator(params.data.literatureData);
    return true;
  }
  agInit(params: any): void {
    this.params = params;
    this.clientUse = this.params.data.literatureData.clientUse;
    this.isInvestor = get(params, 'isInvestor');
    this.showPublicationDate = get(params, 'showPublicationDate');
    this.isSiteIntl = get(params, 'isSiteIntl', true);
    if (!this.isSiteIntl && this.clientUse) {
      this.clientUseValue = this.finraGenerator(params.data.literatureData);
    }
    this.cellvalue = this.detailGenerator(params.data.literatureData);
  }

  detailGenerator(data: LiteratureDocument) {
    if (this.isSiteIntl || !this.clientUse) {
      return detailsGenerator({ literatureData: data }, this.translateService);
    }
    const detailData = [
      {
        label: this.translateService.instant('literature.lit-code'),
        val: data.docId,
        size: 'compact',
      },
      {
        label: this.translateService.instant('literature.next-update'),
        val: data.nextUpdateDate,
        size: 'compact',
      },
    ];
    if (this.showPublicationDate) {
      detailData.splice(1, 0, {
        label: this.translateService.instant('literature.publication-date'),
        val: this.dateFormatter.transform(
          data.publicationDate,
          this.convertDateTo
        ),
        size: 'compact',
      });
    }
    return detailData;
  }
  finraGenerator(data: LiteratureDocument) {
    let clientUseData = [];
    if (data.href) {
      clientUseData = [
        {
          label: this.translateService.instant('literature.client-use'),
          size: 'compact',
        },
      ];
    } else {
      clientUseData = [
        {
          label: this.translateService.instant('literature.client-use'),
          val: `${this.translateService.instant(
            'literature.' + data.clientUse
          )}`,
          size: 'compact',
        },
      ];
    }
    return clientUseData;
  }

  /**
   * Navigates to download link.
   * @param url the link to be navigated
   */
  goToLink(litData: LiteratureDocument, event: MouseEvent) {
    event?.preventDefault();
    event?.stopPropagation();
    this.windowRef.open(litData.finraLink, '_blank');
    this.cartService.checkoutOrder([{ literatureCode: litData.docId, qty: 1 }]);
  }
}
